import React from 'react'
import { pure } from 'recompose'

import {
  ChannelContainerLayout,
  ChannelStructureLayout,
  ChannelNoteLayout,
} from 'components/Public/Layout'

const colors = {
  white: 'rgba(255, 255, 255, .1)',
  grey: 'rgba(224, 224, 224, .4)',
  'grey-dark': 'rgba(200, 200, 200, .4)',
  def: 'rgba(246, 246, 246, 1)',
}

const LoadingLine = pure(
  ({
    size = 14,
    lineWidth = '100%',
    theme = 'white',
    marginBottom = 15,
    marginTop = 0,
    iconClass = false,
    iconSize = false,
    animationDelay = 0,
  }) => {
    const color = colors[theme] || colors.def

    return (
      <div
        className={`flexbox flexbox-align-center loading-line-animation loading-line-animation--delay-${animationDelay}`}
        style={{
          height: iconSize || size,
          marginBottom,
          marginTop,
        }}
      >
        {iconClass && (
          <div className="flexbox-no-grow">
            {React.createElement(iconClass, {
              size: iconSize || size,
              style: { color, marginRight: 8, verticalAlign: '-1px' },
            })}
          </div>
        )}
        <div
          className="flexbox-no-grow width-full radius-normal"
          style={{
            width: lineWidth,
            backgroundColor: color,
            height: size,
          }}
        />
      </div>
    )
  }
)

export const StructureLoading = () => (
  <ChannelStructureLayout>
    <LoadingLine
      animationDelay={1}
      theme="grey"
      lineWidth="80%"
      marginBottom={10}
    />
    <LoadingLine
      animationDelay={1}
      theme="grey"
      lineWidth="60%"
      marginBottom={30}
    />
    <LoadingLine
      animationDelay={1}
      theme="grey"
      lineWidth="80%"
      marginBottom={10}
    />
    <LoadingLine
      animationDelay={1}
      theme="grey"
      lineWidth="60%"
      marginBottom={30}
    />
    <LoadingLine
      animationDelay={1}
      theme="grey"
      lineWidth="80%"
      marginBottom={10}
    />
    <LoadingLine
      animationDelay={1}
      theme="grey"
      lineWidth="60%"
      marginBottom={30}
    />
  </ChannelStructureLayout>
)

export const NoteLoading = () => (
  <ChannelNoteLayout>
    <LoadingLine
      animationDelay={2}
      size={26}
      theme="grey-light"
      lineWidth="80%"
      marginBottom={15}
    />
    <LoadingLine
      animationDelay={2}
      size={26}
      theme="grey-light"
      lineWidth="60%"
      marginBottom={30}
    />
    <LoadingLine
      animationDelay={2}
      theme="grey-light"
      lineWidth="95%"
      marginBottom={10}
    />
    <LoadingLine
      animationDelay={2}
      theme="grey-light"
      lineWidth="100%"
      marginBottom={10}
    />
    <LoadingLine
      animationDelay={2}
      theme="grey-light"
      lineWidth="85%"
      marginBottom={10}
    />
    <LoadingLine
      animationDelay={2}
      theme="grey-light"
      lineWidth="60%"
      marginBottom={10}
    />
  </ChannelNoteLayout>
)

class AppLoading extends React.Component {
  render() {
    return (
      <div className="position-coverer">
        <ChannelContainerLayout>
          <StructureLoading />
          <NoteLoading />
        </ChannelContainerLayout>
      </div>
    )
  }
}

export default AppLoading
